import React from 'react';
import Layout from '../components/Layout';

const TermsConditions: React.FC = () => {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Conditions Générales',
    description:
      'Conditions générales d\'utilisation du site Primorixx. Lisez les conditions avant d\'utiliser nos services.',
    url: 'https://primorixx.com/conditions-generales',
  };

  return (
    <Layout
      title="Conditions Générales"
      description="Conditions générales d'utilisation du site Primorixx. Lisez les conditions avant d'utiliser nos services."
      canonicalUrl="/conditions-generales"
      jsonLd={jsonLd}
    >
      <div className="min-h-screen pt-20">
        <section className="py-20 bg-gradient-to-b from-dark-bg to-dark-surface">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <h1 className="text-5xl md:text-6xl font-bold mb-6 gradient-text">
                Conditions Générales
              </h1>
              <p className="text-lg text-dark-muted mb-8">
                Dernière mise à jour: {new Date().toLocaleDateString('fr-FR')}
              </p>

              <div className="bg-dark-card border border-dark-border rounded-xl p-8 space-y-8">
                <section>
                  <h2 className="text-2xl font-bold text-white mb-4">
                    1. Acceptation des Conditions
                  </h2>
                  <p className="text-dark-muted leading-relaxed">
                    En accédant et en utilisant le site Primorixx, vous acceptez de
                    respecter et d'être lié par ces Conditions Générales d'Utilisation.
                    Si vous n'acceptez pas une partie de ces conditions, vous ne
                    devez pas utiliser notre site.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-bold text-white mb-4">
                    2. Utilisation du Site
                  </h2>
                  <p className="text-dark-muted leading-relaxed mb-4">
                    Vous acceptez d'utiliser le site uniquement à des fins légales et en
                    conformité avec ces conditions. Spécifiquement, vous acceptez de
                    ne pas:
                  </p>
                  <ul className="list-disc list-inside space-y-2 text-dark-muted">
                    <li>Utiliser le site de manière illégale ou non autorisée</li>
                    <li>
                      Tenter d'accéder à des zones restreintes du site sans autorisation
                    </li>
                    <li>
                      Interférer ou interrompre le fonctionnement du site
                    </li>
                    <li>Copier, modifier ou distribuer du contenu sans permission</li>
                    <li>Utiliser le site à des fins commerciales non autorisées</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-2xl font-bold text-white mb-4">
                    3. Âge Minimum
                  </h2>
                  <p className="text-dark-muted leading-relaxed">
                    Vous déclarez et garantissez que vous avez au moins 18 ans.
                    Le site est destiné uniquement aux personnes ayant l'âge légal pour
                    les paris en ligne dans votre juridiction.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-bold text-white mb-4">
                    4. Contenu du Site
                  </h2>
                  <p className="text-dark-muted leading-relaxed">
                    Tout le contenu du site, y compris les textes, graphiques, logos,
                    images et logiciels, est la propriété de Primorixx ou de ses
                    concédants de licence et est protégé par les lois sur le droit d'auteur.
                    Vous ne pouvez pas reproduire, distribuer ou créer des œuvres
                    dérivées sans permission expresse.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-bold text-white mb-4">
                    5. Liens vers des Tiers
                  </h2>
                  <p className="text-dark-muted leading-relaxed">
                    Notre site peut contenir des liens vers des sites tiers. Nous ne
                    sommes pas responsables du contenu ou des pratiques de confidentialité
                    de ces sites. Nous recommandons de consulter les conditions et politiques
                    de confidentialité de tout site tiers que vous visitez.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-bold text-white mb-4">
                    6. Avertissement
                  </h2>
                  <p className="text-dark-muted leading-relaxed">
                    Le site est fourni "tel quel" sans garanties d'aucune sorte.
                    Nous ne garantissons pas que le site sera toujours disponible, sécurisé ou
                    exempt d'erreurs. Vous utilisez le site à vos propres risques.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-bold text-white mb-4">
                    7. Limitation de Responsabilité
                  </h2>
                  <p className="text-dark-muted leading-relaxed">
                    En aucun cas nous ne serons responsables des dommages
                    directs, indirects, accessoires ou consécutifs résultant
                    de l'utilisation ou de l'incapacité d'utiliser le site.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-bold text-white mb-4">
                    8. Jeu Responsable
                  </h2>
                  <p className="text-dark-muted leading-relaxed">
                    Nous promouvons le jeu responsable. Si vous croyez avoir un
                    problème avec les paris, nous recommandons de chercher de l'aide
                    professionnelle. Le jeu peut être addictif et doit être pratiqué
                    avec responsabilité.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-bold text-white mb-4">
                    9. Modifications des Conditions
                  </h2>
                  <p className="text-dark-muted leading-relaxed">
                    Nous nous réservons le droit de modifier ces conditions à tout
                    moment. Les modifications entreront en vigueur immédiatement après leur
                    publication. L'utilisation continue du site après les modifications
                    constitue l'acceptation des nouvelles conditions.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-bold text-white mb-4">
                    10. Loi Applicable
                  </h2>
                  <p className="text-dark-muted leading-relaxed">
                    Ces conditions sont régies par les lois de la France. Tout
                    litige sera soumis à la juridiction exclusive des tribunaux
                    de France.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-bold text-white mb-4">
                    11. Contact
                  </h2>
                  <p className="text-dark-muted leading-relaxed">
                    Si vous avez des questions sur ces Conditions Générales, contactez-nous
                    par e-mail: contact@primorixx.com
                  </p>
                </section>
              </div>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default TermsConditions;

